import axiosInstance from '@/app/api/axiosInstance';
import { TaxComponentAccountCreate, TaxComponentAccountUpdate, TaxComponentAccountResponse } from '@/app/types';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';

export const listTaxComponentAccounts = async (
  params: ListQueryParams,
  organizationId?: number
): Promise<PaginatedResponse<TaxComponentAccountResponse>> => {
  try {
    const requestParams = {
      ...params,
      ...(params.filters && typeof params.filters === 'string'
        ? { filters: params.filters }
        : organizationId 
            ? { filters: JSON.stringify({ organization_id: organizationId }) }
            : {})
    };

    const response = await axiosInstance.get<PaginatedResponse<TaxComponentAccountResponse>>(
      '/tax-component-accounts/', 
      { params: requestParams }
    );
    
    return response.data;
  } catch (error) {
    console.error('Failed to list tax component accounts:', error);
    throw error;
  }
};

export const getTaxComponentAccount = async (taxComponentAccountId: number): Promise<TaxComponentAccountResponse> => {
  try {
    const response = await axiosInstance.get<TaxComponentAccountResponse>(
      `/tax-component-accounts/${taxComponentAccountId}`
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to get tax component account with ID ${taxComponentAccountId}:`, error);
    throw error;
  }
};

export const createTaxComponentAccount = async (
  data: TaxComponentAccountCreate, 
  organizationId?: number
): Promise<TaxComponentAccountResponse> => {
  try {
    const taxComponentAccountData = {
      ...data,
      ...(organizationId ? { organization_id: organizationId } : {})
    };
    
    const response = await axiosInstance.post<TaxComponentAccountResponse>(
      '/tax-component-accounts/', 
      taxComponentAccountData
    );
    return response.data;
  } catch (error) {
    console.error('Failed to create tax component account:', error);
    throw error;
  }
};

export const updateTaxComponentAccount = async (
  taxComponentAccountId: number, 
  data: TaxComponentAccountUpdate
): Promise<TaxComponentAccountResponse> => {
  try {
    const response = await axiosInstance.patch<TaxComponentAccountResponse>(
      `/tax-component-accounts/${taxComponentAccountId}`, 
      data
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to update tax component account with ID ${taxComponentAccountId}:`, error);
    throw error;
  }
};

export const deleteTaxComponentAccount = async (taxComponentAccountId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/tax-component-accounts/${taxComponentAccountId}`);
  } catch (error) {
    console.error(`Failed to delete tax component account with ID ${taxComponentAccountId}:`, error);
    throw error;
  }
}; 